import { config } from '@react-spring/web';

export const effectConfig = [
  {
    name: 'image-fade',
    chinese: '淡入淡出',
    cfg: {
      from: { opacity: 0 },
      enter: { opacity: 1 },
      leave: { opacity: 0 },
      // 这个效果看起来慢一些，适合一些
      config: config.molasses,
      reset: true // 至少保留一个，方便后续赋值不会被ts认为是错误的
    }
  },
  {
    name: 'to-left',
    chinese: '向左滚动',
    cfg: {
      from: { opacity: 0, transform: 'translate3d(100%,0,0)' },
      enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
      // 用100%方便衔接
      leave: { opacity: 0, transform: 'translate3d(-100%,0,0)' }
    }
  },
  // {
  //   name: 'to-right',
  //   chinese: '向右滚动',
  //   cfg: {
  //     from: { opacity: 0, transform: 'translate3d(-100%,0,0)' },
  //     enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
  //     leave: { opacity: 0, transform: 'translate3d(100%,0,0)' }
  //   }
  // },
  {
    name: 'right-top-in',
    chinese: '右上滑入',
    cfg: {
      from: { opacity: 0.5, transform: 'translate3d(100%,-100%,0)' },
      enter: { opacity: 1, transform: 'translate3d(0,0,0)' },
      // 不知道为啥下面的transform其实没有生效
      leave: { opacity: 0, transform: 'translate3d(-100%,100%,0)' }
    }
  },
  {
    name: 'right-bottom-in',
    chinese: '右下滑入',
    cfg: {
      from: { opacity: 0.5, transform: 'translate3d(100%,100%,0)' },
      enter: { opacity: 1, transform: 'translate3d(0,0,0)' },
      // 不知道为啥下面的transform其实没有生效
      leave: { opacity: 0, transform: 'translate3d(-100%,-100%,0)' }
    }
  },
  {
    name: 'to-left2', // 左划，带上一点缩小的效果
    chinese: '缩放滚动',
    cfg: {
      from: {
        opacity: 0,
        transform: `translate3d(100%,0,0) scale(0.5)`
      },
      enter: {
        opacity: 1,
        transform: 'translate3d(0%,0,0) scale(1)'
      },
      leave: {
        opacity: 0,
        transform: `translate3d(-100%,0,0) scale(0.5)`
      },
      config: config.slow
    }
  },
  // {
  //   name: 'to-right2',
  //   chinese: '向右滚动2',
  //   cfg: {
  //     from: {
  //       opacity: 0,
  //       transform: `translate3d(-100%,0,0) scale(0.5)`
  //     },
  //     enter: {
  //       opacity: 1,
  //       transform: 'translate3d(0%,0,0) scale(1)'
  //     },
  //     leave: {
  //       opacity: 0,
  //       transform: `translate3d(100%,0,0) scale(0.5)`
  //     },
  //     config: config.slow
  //   }
  // },
  {
    name: 'shrink',
    chinese: '轻微缩小',
    cfg: {
      from: { opacity: 0, transform: 'scale(1.1)' },
      enter: { opacity: 1, transform: 'scale(1)' },
      leave: { opacity: 0, transform: 'scale(0.9)' },
      config: config.molasses
    }
  }
].map(one => {
  // 注意，因为允许中途变更效果，不带reset会导致output异常的warning
  // 先临时注释掉，因为客户反馈 每张照片转换的时候出现黑屏
  // one.cfg.reset = true;
  return one;
});

export const effectList = effectConfig
  .map(cfg => {
    return {
      key: cfg.name,
      name: cfg.chinese
    };
  })
  .concat([
    {
      key: 'random',
      name: '随机效果'
    }
  ]);

const getRandEffectConfig = function() {
  const randIndex = Math.floor(Math.random() * effectConfig.length);
  //随机模式下因为一直在该配置文件，可能会导致这个异常： The arity of each "output" value must be equal
  // 所以加入了reset=true，让他每次相当于都是从0开始渲染
  return effectConfig[randIndex].cfg;
};
const getEffectConfig = function(name: string) {
  if (name === 'random') {
    return getRandEffectConfig();
  }
  const theConfig = effectConfig.find(one => one.name === name);
  if (theConfig) {
    return theConfig.cfg;
  }
  return {};
};

export default getEffectConfig;
